// extracted by mini-css-extract-plugin
export default {"InnerWrapper":"AppleLogin_InnerWrapper__vqDTg","AppleSvg":"AppleLogin_AppleSvg__jM7O6"};